import { ChartData } from "../Editor/Displays/Chart";
import { renderChart, renderDisplayChart, transformDataToChartData } from "./RenderChart";


export function loadChart(item:HTMLElement, data:ChartData){
    const chartData = transformDataToChartData(data);
    chartData.chart.width = data.width;
    // chartData.chart.height = data.height;
    
    
    
    renderDisplayChart(chartData, item);
}